import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { readUnits, writeUnits, toggleUnits } from "./units";

// The viewer's display-units preference as React state, shared by everything on the page that shows a measurement
// (the canvas, the export menu, the report): changing it in one place updates the others at once, and it is
// remembered per viewer. A display preference only — see utils/units.js.

const EVENT = "cs:units-change";

export function useUnitsPreference() {
  const [units, setUnitsState] = useState(() => readUnits());
  useEffect(() => {
    const on = () => setUnitsState(readUnits());
    window.addEventListener(EVENT, on);
    return () => window.removeEventListener(EVENT, on);
  }, []);
  const setUnits = useCallback((next) => {
    writeUnits(next);
    setUnitsState(next);
    window.dispatchEvent(new Event(EVENT));
  }, []);
  const toggle = useCallback(() => setUnits(toggleUnits(readUnits())), [setUnits]);
  return [units, setUnits, toggle];
}

/** The units in force for components below a provider (the canvas provides its own). */
export const UnitsContext = createContext("imperial");
export const useUnits = () => useContext(UnitsContext);
